import { TableCell } from "@mui/material";

type Props = {
  columns: any[];
  month: number;
  year: number;
};

const CalendarGridDailyVisit: React.FC<Props> = ({ columns, year, month }) => {
  const daysInMonth = new Date(year, month, 0).getDate();

  const daysArray = Array.from(
    { length: daysInMonth },
    (_, index) => index + 1
  );
  return (
    <>
      <TableCell
        style={{
          border: "1px solid white",
          padding: 0,
          backgroundColor: "#f9fafd",
          width: 20
        }}
      ></TableCell>
      {columns.map((column) => (
        <TableCell
          padding="none"
          style={{
            border: "1px solid white",
            width: column.field === "Status" ? 20 : 80,
            textAlign: "center",
            padding: 0,
            backgroundColor: "#f9fafd",
            fontSize: 12,
          }}
          key={column.field}
        >
          {column.field === "Status" ? "" : column.field}
        </TableCell>
      ))}
      <TableCell
        style={{
          textAlign: "center",
          border: "1px solid white",
          padding: 0,
          width: 40,
          backgroundColor: "#f9fafd",
          fontSize: 12,
        }}
      >
        Total
      </TableCell>
      {daysArray.map((day) => (
        <TableCell
          style={{
            border: "1px solid white",
            padding: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            backgroundColor: "#f9fafd",
            fontSize: 12,
            textAlign: "center",
          }}
        >
          {day}
        </TableCell>
      ))}
    </>
  );
};

export default CalendarGridDailyVisit;
